import React, { ReactNode } from "react"
import clsx from "clsx"
import { FetchPageContent } from "../../app-core/_common/sanity/fetch-page-content"
import NextButton from "../NextButton/NextButton"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { VisibleTabletUp } from "../ResponsiveComponents"
import { WebQuoteExitIntent } from "../../app-core/v3/_common/web-quote-exit-intent"
import { BookingSteps } from "../../app-core/_common/steps/booking-steps"
import SidebarHeader from "./SidebarHeader/SidebarHeader"
import PriceSummary from "./PriceSummary/PriceSummary"
import styles from "./Sidebar.module.scss"
import ExpandableReceipt from "./ExpandableReceipt/ExpandableReceipt"

export type SidebarProps = {
    className?: string
    sanityContent: FetchPageContent
    activeStep: BookingSteps
    onNextClick: () => void
    isNextEnabled: boolean
    showNextButton: boolean
    webQuoteExitIntent: WebQuoteExitIntent
    boxes?: ReactNode
}

const Sidebar: React.FC<SidebarProps> = ({
    className,
    sanityContent,
    activeStep,
    onNextClick,
    isNextEnabled,
    showNextButton,
    webQuoteExitIntent,
    boxes,
}) => {
    const [state] = useECommerceMachine()

    const courtesyHoldBox = state.context.flowVersion.ui.courtesyHoldBoxSidebar(state)
    const automaticSelectionOfSuiteNumberInProgress =
        state.context.flowVersion.ui.automaticSelectionOfSuiteNumberInProgress(state)

    return (
        <aside className={clsx(styles.aside, className)} data-test-id="sidebar" data-content-name="sidebar">
            <div className={styles.wrapper}>
                <SidebarHeader sanityContent={sanityContent} webQuoteExitIntent={webQuoteExitIntent} />
                <div className={styles.content}>
                    {state.context.flowVersion.ui.stepsRecap(activeStep)}
                    <PriceSummary />
                    {showNextButton && (
                        <NextButton
                            full
                            onClick={onNextClick}
                            disabled={!isNextEnabled}
                            className={styles.nextButton}
                            loading={automaticSelectionOfSuiteNumberInProgress}
                        />
                    )}
                </div>
                <ExpandableReceipt className={styles.footer} />
            </div>

            <VisibleTabletUp>
                {courtesyHoldBox}
                {boxes}
            </VisibleTabletUp>
        </aside>
    )
}

export default Sidebar
